const businessLandingES = {
	hero: {
		title: "Organiza tu negocio. Llena tu agenda. Sin filas.",
		subtitle:
			"Sin Fila automatiza tus reservas, reduce ausencias y atrae más clientes.",
		primaryCta: "Empezar ahora",
		secondaryCta: "Ver cómo funciona",
	},

	problem: {
		title: "¿Te pasa esto?",
		items: [
			"Respondes WhatsApp todo el día (y de noche también)",
			"Horarios cruzados y espacios vacíos",
			"Clientes ven la fila y se van",
			"Llegan sin turno y se desesperan",
		],
		highlight: "Cada cliente que se va por la fila es dinero perdido.",
		stat:
			"Muchos negocios pierden hasta un 20% de sus ingresos por mala gestión.",
	},

	solution: {
		title: "Sin Fila lo soluciona",
		business: {
			title: "Para tu negocio",
			items: [
				"Agenda automática 24/7",
				"Confirmaciones y recordatorios",
				"Horarios flexibles y bloqueo de horas",
				"Perfil público para nuevos clientes",
				"Promociones para horas flojas",
			],
		},
		clients: {
			title: "Para tus clientes",
			items: [
				"Reservar sin llamadas",
				"Confirmación inmediata",
				"Disponibilidad en vivo",
				"Recordatorios automáticos",
				"Reprogramar o cancelar fácil",
			],
		},
	},

	visuals: {
		title: "Así se ve Sin Fila",
		items: [
			"Vista del calendario",
			"Perfil del negocio",
			"Pantalla para agendar",
			"Confirmación del cliente",
		],
	},

	pricing: {
		title: "Un plan simple, todo incluido",
		mainPrice: "$15 USD / mes",
		mainDesc: "Primer usuario",
		extraPrice: "$12 USD / mes",
		extraDesc: "Por cada usuario adicional",
		includes: [
			"Reservas online 24/7",
			"Confirmaciones y recordatorios",
			"Agenda en tiempo real",
			"Perfil público",
			"Promociones y espacios disponibles",
			"Cancelar cuando quieras",
		],
		note:
			"Paga con tarjeta de débito o crédito. Tu banco convierte automáticamente de pesos a USD.",
		referral:
			"Programa de referidos: un referido = un usuario gratis por mes.",
	},

	final: {
		title: "¿Listo para trabajar sin fila?",
		subtitle:
			"Activa tu negocio en 15 minutos. Cobro automático mensual. Sin contratos.",
		cta: "Empezar ahora",
		storeText: "Disponible para iOS y Android",
	},
};

export default businessLandingES;
